import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class IconComponent {
  @Input()
  name: string;
  @Input()
  hasCount = false;
  @Input()
  count = 0;
  @Input()
  disabled = false;
  @Input()
  colourClass = '';
  iconClass(): string {
    return `fem-icon fem-icon-${this.name} ${this.disabled ? 'disabled-icon' : this.colourClass} `;
  }

  getCount() {
    return this.count > 99 ? '99+' : this.count.toString();
  }
}
